import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {AddressRequestType} from "../../../../addresses/angular/types/address-request.type";
import {LocationType} from "../../../../commons/types/location.type";
import {uniq} from "lodash";
import {VisitPlanRouteModel, VisitScheduleActivityDetailsModel} from "../../../models/visit-plan-route.model";
import {TaskDetailedServiceTimeModel} from "../../../../tasks/models/task-detailed-service-time.model";
import {Address} from "../../../../addresses/models/address.model";
import {VisitPlanRouteCallServiceTimeModel} from "../../../models/visit-plan-route-call-service-time.model";
import {bzIconEditOutline} from "@bringoz/ui/icons";

require('./visit-plan-route-tasks-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-route-tasks-panel-list-item',
  templateUrl: './visit-plan-route-tasks-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanRouteTasksPanelListItemComponent implements OnInit, OnChanges {

  @Input() activity: any;
  @Input() activityDetailsMap?: any;
  @Input() details?: VisitScheduleActivityDetailsModel;
  @Input() isActivityLocked: Boolean;
  @Input() index: number;
  @Input() job?: any;
  @Input() jobs?: any;
  @Input() route?: VisitPlanRouteModel;
  @Input() isRunning?: boolean;
  @Input() agentColorMap: { [key: string]: string };
  @Input() settings: any;
  @Input() highlightedActivity?: any;
  @Input() itemElementSize: string;
  @Input() isSmallScreen: boolean;
  @Input() selectedJobIds: string[];
  @Input() isSelected: boolean;
  @Input() isDisplayRetrips: boolean;
  @Input() queryText: string;
  @Input() callServiceTimeMap: { [callId: string]: VisitPlanRouteCallServiceTimeModel };
  @Input() isDayDispatched: boolean;
  @Output() onViewJob = new EventEmitter<boolean>();
  @Output() onToggle = new EventEmitter<{ item: any, isSelected: boolean }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();
  @Output() onEditServiceTime = new EventEmitter<{ callId: string, event: MouseEvent }>();

  readonly icons = {editOutline: bzIconEditOutline};

  public barcodesList: string[];
  public labels: string[];
  public routeColor: string;
  public dateRange: { notBefore: string, notAfter: string };
  public isHover: boolean;
  public stopRef?: any;
  public query: any;
  public type: AddressRequestType;
  public showAddressIcon: boolean;
  public isAccountHover: boolean;
  public jobIds: string[];
  public isObligatedTimeWindow: boolean = false;
  public isShowObligateTimeWindowToggle: boolean = false;
  public isHighlightObligateTimeWindowToggle: boolean = false;
  public accountsName: string[] = [];
  public activitySkills: string[];
  public address: Address;
  public isExpanded: boolean = false;
  public isIndeterminate: boolean = false;
  public callServiceTime?: VisitPlanRouteCallServiceTimeModel;
  public isServiceTimeEditable: boolean = false;

  constructor(@Inject('planningCommonService') private planningCommonService, @Inject('$timeout') private $timeout) {
  }

  ngOnInit() {
    this.setRouteColor();
    this._setSkills();

    if (this.job?.packages) {
      this.barcodesList = this.job.packages.filter((p) => !!p.barcode).map((p) => p.barcode);

      this.labels = [];
      this.job.packages?.forEach(p => {
        if (p.labels?.length) {
          this.labels = this.labels.concat(p.labels);
        }
      })
    }

    if (this.activity?.type === 'GROUP' && this.activity?.stopActivities?.length > 0) {
      this.accountsName = uniq(this.activity.stopActivities?.map(a => a.accountName));
    } else {
      this.accountsName.push(this.activity?.accountName || '---');
    }

    if (this.job) {
      this.stopRef = _.find(this.job.stops, (s: any) => {
        return !!this.activity.stopIds?.length ? _.includes(this.activity.stopIds, s.id) : s.id === this.activity.stopId
      })

      this.query = {
        api: '/planning/projects/{projectId}/drafts/{draftId}/address/{addressId}',
        draftId: this.job.draftId,
        projectId: this.job.projectId
      }
      this.type = AddressRequestType.Planning;
    }

    // For GROUP activities, search through all jobs
    if (!this.stopRef && this.jobs?.length) {
      const allStops = _.flatMap(this.jobs, 'stops');
      this.stopRef = _.find(allStops, (s: any) => {
        return !!this.activity.stopIds?.length ? _.includes(this.activity.stopIds, s.id) : s.id === this.activity.stopId
      });
    }

    this.jobIds = this.jobs?.map((j) => j.id);
    this._setObligateTimeWindow();

    if (this.activity.type === "GROUP") {
      const hasSelected = this.activity.stopActivities.some(a => this.selectedJobIds?.includes(a.jobId));
      const hasUnselected = this.activity.stopActivities.some(a => !this.selectedJobIds?.includes(a.jobId));

      this.isIndeterminate = hasSelected && hasUnselected;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.callServiceTimeMap || changes.details || changes.route) {
      this._setCallServiceTime();
    }

    if (changes.jobs && !changes.jobs.isFirstChange()) {
      this._setObligateTimeWindow();
    }

    if (changes.selectedJobIds && this.activity.type === "GROUP") {
      const hasSelected = this.activity.stopActivities.some(a => this.selectedJobIds?.includes(a.jobId));
      const hasUnselected = this.activity.stopActivities.some(a => !this.selectedJobIds?.includes(a.jobId));

      this.isIndeterminate = hasSelected && hasUnselected;
    }
  }

  isValidAddressType(address) {
    return address.locationType == LocationType.ACCOUNT ||
      address.locationType == LocationType.DEPOT ||
      address.locationType == LocationType.RESOURCE ||
      address.locationType == LocationType.CUSTOMER;
  }


  onHover(isHover) {
    this.isShowObligateTimeWindowToggle = isHover;
    if (this.route.locked) return;
    this.isHover = isHover;
    this.$timeout(0).then(() => {
    });
  }

  isHighQualityAddress(address) {
    return address && address.addressResolvingInfo &&
      address.addressResolvingInfo.qualityGroup == "High";
  }

  onClick(event: MouseEvent) {
    if (event.ctrlKey) {
      this.onToggle.emit({ item: this.activity, isSelected: !this.isSelected });
      this.$timeout(0).then(() => {
      });
    }
  }

  private setRouteColor() {
    this.routeColor = !!this.agentColorMap ? this.agentColorMap[this.route.resource.agentId] : this.planningCommonService.getRouteColor(this.route)
    // this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

  private _setSkills() {
    const PRIORITY_ORDER = ['Merchandise', 'Order', 'Delivery'] as const;
    const prioritySet = new Set(PRIORITY_ORDER);
    let skills = this.details?.skills || [];

    if (this.activity.stopActivities) {
      const ids = _.map(this.activity.stopActivities, 'id');
      let bundleSkills = [];
      this.route.activityDetails?.forEach((d) => {
        if (_.includes(ids, d.activityId)) {
          bundleSkills = bundleSkills.concat(d.skills);
        }
      })

      skills = _.uniq(bundleSkills);
    }

    const prioritized = PRIORITY_ORDER.filter(skill =>
      skills.includes(skill)
    );

    const rest = skills.filter(skill =>
      !prioritySet.has(skill)
    );

    this.activitySkills = [...prioritized, ...rest];
  }

  private _setCallServiceTime() {
    // GROUP details point to one of its stops, so the call is edited from the expanded bundled activities
    this.callServiceTime = this.activity?.type !== 'GROUP' ? this.callServiceTimeMap?.[this.details?.callId] : undefined;
    this.isServiceTimeEditable = !!this.callServiceTime?.isEditable && !this.route?.locked;
  }

  private _setObligateTimeWindow() {
    this.isObligatedTimeWindow = false;
    const stops = _.flatMap(this.jobs, 'stops');

    if (!stops?.length) {
      return;
    }
    this.isObligatedTimeWindow = stops.every((stop) => !!stop.obligateTimeWindow);
  }

  get displayAccountName(): string {
    // For GROUP activities, get account name from first stopActivity
    if (this.activity?.type === 'GROUP' && this.activity?.stopActivities?.length > 0) {
      return this.activity.stopActivities[0]?.accountName || '---';
    }
    // For regular activities, use the activity's accountName
    return this.activity?.accountName || '---';
  }

  get displaySegment(): number | undefined {
    // For GROUP activities, get the segment from first stopActivity
    if (this.activity?.type === 'GROUP') {
      return this.activity?.stopActivities?.[0]?.accountReference?.strategicPriority?.segment ?? undefined;
    }
    return this.activity?.accountReference?.strategicPriority?.segment ?? undefined;
  }

}
